import { ThemeProvider, CssBaseline } from "@mui/material";
import { muiTheme } from "./muiTheme";

interface Props {
  children: React.ReactNode;
}

export const AppThemeProvider = ({ children }: Props) => (
  <ThemeProvider theme={muiTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);
